import { Fragment, useMemo } from 'react';
import { Feature } from '../../../types/catalog';
import FileCard from './elements/file-card';
import FeatureTable from './elements/feature-table';
import LogisticFeatureTable from './elements/logistic-feature-table';
import ProductCarousel from './elements/product-carousel';
import FeatureCarousel from './elements/features-carousel';
import SwiperGallery from './elements/swiper-gallery';
import Product, { ProductRenderProps, ShowKey } from '../../product';
import NewItkNotFound from './not-found';
import { Swiper, SwiperSlide } from 'swiper/react';

const navLinks = {
    designFeatures: 'Особенности конструкции',
    specs: 'Характеристики',
    files: 'Документация',
    related: 'Совместно применяемые изделия',
    analogs: 'Близкая по параметрам продукция',
};

const ProductRender = ({ show, product }: ProductRenderProps) => {
    const visibleTabs = useMemo(() => {
        return Object.entries(navLinks).filter(([key]) => show[key as ShowKey]);
    }, [show]);
    if (!product) {
        return <NewItkNotFound>Товар не найден</NewItkNotFound>;
    }
    const allSpecs = show.specs ? (product.etim?.features as Feature[]) : [];
    const halfSpecsLength = Math.ceil(allSpecs.length / 2);
    const halfSpecs1 = allSpecs.slice(0, halfSpecsLength);
    const halfSpecs2 = allSpecs.slice(halfSpecsLength);


    return (
        <Fragment>
            <main className="content product-page inner-page">
                <section className="product-main" id="product">
                    <div className="container">
                        <div className="product-main__cont">
                            <div className="product-images">
                                {product.novelty && (
                                    <span className="iek-prodcat-catalog-detail-novelty">Новинка</span>
                                )}
                                <SwiperGallery
                                    images={product.imageUrls}
                                    variants={product.imageUrlsVariants}
                                />
                            </div>
                            <div className="product-main__content">
                                <div>Артикул: {product.article}</div>
                                <div className="product-main__txt-cont">
                                    {product.description?.split('\n').map((t, idx) => (
                                        <p className="product-main__txt" key={idx}>
                                            {t}
                                        </p>
                                    )) || 'Описание отсутствует'}
                                </div>
                                <a href="#section-list" className="product-main__link-more">
                                    <span>Подробное описание</span>
                                    <svg
                                        className="icon"
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="#000"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    >
                                        <path d="M4 12h16M14 6l6 6-6 6" />
                                    </svg>
                                </a>
                                <div className="product-main__btn-cont">
                                    <a
                                        href={`/gde-kupit/?article=${product.article}`}
                                        className="btn btn--filled"
                                    >
                                        <span className="btn__txt">Где купить?</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <Swiper
                            freeMode
                            watchOverflow
                            slidesOffsetAfter={40}
                            mousewheel={{ forceToAxis: true }}
                            slidesPerView="auto"
                            className="tabs-swiper tabs-swiper--horizontal"
                            id="section-list"
                        >
                            {visibleTabs.map(([code, name]) => (
                                <SwiperSlide key={code}>
                                    <a className="tabs-swiper__item active" href={'#' + code}>
                                        {name}
                                    </a>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                </section>
                {show.designFeatures && (
                    <section className="product-features" id="designFeatures">
                        <FeatureCarousel features={product.designFeatures} />
                    </section>
                )}
                <div className="product-table">
                    <div className="container">
                        <h2 className="product-table__title" id="specs">
                            Характеристики
                        </h2>
                        {show.specs && (
                            <>
                                <span className="product-table__subtitle">Технические характеристики</span>
                                <div className="product-table__cont">
                                    <FeatureTable features={halfSpecs1} />
                                    <FeatureTable features={halfSpecs2} />
                                </div>
                            </>
                        )}

                        <div className="product-table__cont">
                            {show.usage && (
                                <div className="product-table__wrapper">
                                    <span className="product-table__subtitle">
                                        Эксплуатационные параметры
                                    </span>
                                    <FeatureTable features={product.leftPeriod as Feature[]} />
                                </div>
                            )}
                            {show.complects && (
                                <div className="product-table__wrapper">
                                    <span className="product-table__subtitle">Комплектация</span>
                                    <FeatureTable features={product.complects as Feature[]} />
                                </div>
                            )}
                        </div>
                        <span className="product-table__subtitle">Логистические параметры</span>
                        <div className="product-table__cont">
                            <LogisticFeatureTable features={product.logisticParams} />
                        </div>
                    </div>
                </div>
                {show.files && (
                    <section className="product-documentation" id="files">
                        <div className="container">
                            <h2 className="product-documentation__title">Документация</h2>
                            <div className="product-documentation-items">
                                {product.files.map((f, idx) => (
                                    <FileCard key={idx} fileGroup={f} />
                                ))}
                            </div>
                        </div>
                    </section>
                )}
                {show.related && (
                    <section className="similar-products" id="related">
                        <ProductCarousel title="Совместно применяемые изделия" products={product.analogs} />
                    </section>
                )}
                {show.analogs && (
                    <section className="similar-products" id="analogs">
                        <ProductCarousel title="Близкая по параметрам продукция" products={product.analogs} />
                    </section>
                )}
            </main>
        </Fragment>
    );
};

export function NewItkProduct() {
    return <Product render={ProductRender} />;
}

export default NewItkProduct;
